define('SageDotCom/Components/SelectButton',[
    "jquery",
    "score_bootstrap/Components/Button",
    "eventManager",
    "SageDotCom/DataLayer/Events/supportProductSelection",
    "SageDotCom/DataLayer/tealium"
],
    function ($, button, eventManager, eventSchema, tealium) {
        function SelectButton(scope, clickMessagesTransmitting, stateChangeMessages, onShowMessagesPerformer, onHideMessagePerformer, xPerienceXml, buttonOnSelect, buttonOnLoad, chosenBusinessSize) {
            if (chosenBusinessSize == '[Select business size]') {
                chosenBusinessSize = '(not set)';
            }

            eventManager.subscribe('select-toggled', function () {
                $(scope).text(buttonOnLoad);
            });

            $(scope).on('click', function () {
                eventManager.trigger('select-toggled');
                $(scope).text(buttonOnSelect);

                // find parent element and grab it's text
                var product = $(scope).parent().closest("[id]");
                var productLabel = '(not set)';
                // remove button text from found element
                if (product) {
                    productLabel = product.text().replace(buttonOnSelect, '');
                }

                var obj = eventSchema.GenerateEventMetadata(scope, buttonOnLoad, productLabel, chosenBusinessSize);

                tealium.event(obj);
            });

            var buttonScope = new button(scope,
                clickMessagesTransmitting || [],
                stateChangeMessages || [],
                onShowMessagesPerformer || [],
                onHideMessagePerformer || []);

            if (xPerienceXml && xPerienceXml.length > 0) {
                require(["XP/XPRuleLoader"], function (module) {
                    var ruleLoader = module.hasOwnProperty('XPRuleLoader') && module.XPRuleLoader instanceof Function ? new module.XPRuleLoader() /* named load */
                        : module.__esModule === !0 && module.hasOwnProperty("default") && module.default instanceof Function ? new module.default() /* default module load */
                            : module instanceof Function ? new module() /* old fashioned modules */
                                : console.log('Cannot load XPRuleLoader module to load XPerience Rules');

                    if (ruleLoader) {
                        ruleLoader.applyRules(button, xPerienceXml);
                    }
                });
            }

            return buttonScope;


        }

        return function initSelectButton(args) {
            return args.IsExperienceEditorEditing === false
                ? new SelectButton(args.scope, args.ClickMessagesTransmitting, args.StateChangeMessagesTransmitting, args.ShowActionMessages, args.HideActionMessages, args.xPerienceXml, args.ButtonOnSelect, args.ButtonOnLoad, args.ChosenBusinessSize)
                : null;
        };
    });
